import React, { Component } from "react";
import {
  Card, CardBody, Button, Input, FormGroup, Label, Row, Col,
  Alert,
} from "reactstrap";
import AiAdminLayout from "./layout";
import { fetchApi, putApi, postApi } from "./api";

class AiAdminConfigs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
      loading: true,
      saving: false,
      message: "",
      messageType: "success",
    };
  }

  async componentDidMount() {
    await this.loadConfig();
  }

  loadConfig = async () => {
    try {
      const config = await fetchApi("/global-config");
      this.setState({ config, loading: false });
    } catch (err) {
      // No config yet — show empty form
      this.setState({
        config: {
          provider: "gemini",
          gemini_api_key: "",
          openai_api_key: "",
          bot_persona: "Bạn là nhân viên hỗ trợ khách hàng thân thiện, nhiệt tình của cửa hàng.",
        },
        loading: false,
      });
    }
  };

  handleChange = (field, value) => {
    this.setState((prev) => ({
      config: { ...prev.config, [field]: value },
    }));
  };

  handleSave = async () => {
    const { config } = this.state;
    this.setState({ saving: true, message: "" });
    try {
      const updated = config.id
        ? await putApi("/global-config", config)
        : await postApi("/global-config", config);
      this.setState({
        config: updated,
        saving: false,
        message: "Configuration saved successfully!",
        messageType: "success",
      });
      setTimeout(() => this.setState({ message: "" }), 3000);
    } catch (err) {
      console.error("Save error:", err);
      this.setState({
        saving: false,
        message: "Failed to save configuration",
        messageType: "danger",
      });
    }
  };

  render() {
    const { config, loading, saving, message, messageType } = this.state;

    return (
      <AiAdminLayout>
        <h4 className="font-weight-bold mb-4">AI Configuration</h4>
        <p className="text-muted mb-4" style={{ fontSize: 13 }}>
          Global AI settings applied to all shops. API keys and persona are shared across all stores.
        </p>

        {message && (
          <Alert color={messageType} className="mb-3" style={{ fontSize: 13 }}>
            {message}
          </Alert>
        )}

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border spinner-border-sm text-primary" />
          </div>
        ) : (
          <Row>
            <Col lg={8}>
              {/* Provider & Keys */}
              <Card className="mb-4" style={{ borderRadius: 8 }}>
                <CardBody>
                  <h6 className="font-weight-bold mb-3">Provider Settings</h6>
                  <FormGroup>
                    <Label style={{ fontSize: 13 }}>Primary Provider</Label>
                    <Input
                      type="select"
                      value={config.provider || "gemini"}
                      onChange={(e) => this.handleChange("provider", e.target.value)}
                    >
                      <option value="gemini">Google Gemini (Recommended)</option>
                      <option value="openai">OpenAI</option>
                    </Input>
                    <small className="text-muted">
                      If primary fails, the other provider will be used as backup automatically.
                    </small>
                  </FormGroup>

                  <FormGroup>
                    <Label style={{ fontSize: 13 }}>Gemini API Key</Label>
                    <Input
                      type="password"
                      value={config.gemini_api_key || ""}
                      onChange={(e) => this.handleChange("gemini_api_key", e.target.value)}
                      placeholder="AIza..."
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label style={{ fontSize: 13 }}>OpenAI API Key</Label>
                    <Input
                      type="password"
                      value={config.openai_api_key || ""}
                      onChange={(e) => this.handleChange("openai_api_key", e.target.value)}
                      placeholder="sk-..."
                    />
                  </FormGroup>
                </CardBody>
              </Card>

              {/* Bot Persona */}
              <Card className="mb-4" style={{ borderRadius: 8 }}>
                <CardBody>
                  <h6 className="font-weight-bold mb-3">Bot Persona</h6>
                  <FormGroup>
                    <Label style={{ fontSize: 13 }}>System Prompt</Label>
                    <Input
                      type="textarea"
                      rows={6}
                      value={config.bot_persona || ""}
                      onChange={(e) => this.handleChange("bot_persona", e.target.value)}
                      placeholder="Mô tả tính cách và hành vi của bot AI..."
                    />
                    <small className="text-muted">
                      This persona is used as system instruction for all AI conversations across all shops.
                    </small>
                  </FormGroup>
                </CardBody>
              </Card>

              {/* Save */}
              <Button color="primary" onClick={this.handleSave} disabled={saving}>
                {saving ? "Saving..." : "Save Configuration"}
              </Button>
            </Col>

            <Col lg={4}>
              {/* Info Card */}
              <Card style={{ borderRadius: 8, backgroundColor: "#f8f9ff" }}>
                <CardBody>
                  <h6 className="font-weight-bold mb-3" style={{ color: "#667eea" }}>
                    <i className="simple-icon-info mr-2" />
                    How it works
                  </h6>
                  <ul className="mb-0" style={{ fontSize: 12, color: "#555", paddingLeft: 18 }}>
                    <li className="mb-2">
                      AI is <strong>always enabled</strong> for all shops. No per-shop toggle needed.
                    </li>
                    <li className="mb-2">
                      <strong>Backup</strong> is always on — if the primary provider fails, the secondary is used automatically.
                    </li>
                    <li className="mb-2">
                      API keys are shared across all shops. Token usage is tracked per shop in the <strong>Shop Usage</strong> tab.
                    </li>
                    <li className="mb-2">
                      The <strong>Bot Persona</strong> defines the AI assistant's personality and behavior.
                    </li>
                  </ul>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </AiAdminLayout>
    );
  }
}

export default AiAdminConfigs;
